import React from 'react';
import * as Yup from 'yup';
import { find, matchesProperty } from 'lodash';

class FieldsetsGenerator {
  constructor(fieldsets, fieldsetComponents) {
    this.fieldsetComponents = fieldsets.map(({ type, options }) => {
      const Fieldset = find(fieldsetComponents, matchesProperty('type', type));
      if (!Fieldset) throw new TypeError(`Unknown fieldset type "${type}"`);
      return { Fieldset, type, options };
    });
  }

  Fieldsets = props =>
    this.fieldsetComponents.map(({ Fieldset, type, options }, index) => (
      <Fieldset key={type} {...props} options={options} isTop={index === 0} />
    ));

  get initialValues() {
    return Object.assign(
      {},
      ...this.fieldsetComponents.map(({ Fieldset, options }) =>
        Fieldset.initialValues({ ...options })
      )
    );
  }

  get validationSchema() {
    const validationSchema = Object.assign(
      {},
      ...this.fieldsetComponents.map(({ Fieldset, options }) =>
        Fieldset.validationSchema({ ...options })
      )
    );
    return Yup.object().shape(validationSchema);
  }
}

export default FieldsetsGenerator;
